import React, { useEffect, useState } from 'react';
import TagProduct from './TagProduct';
import Search from '../../../Assets/Modals/SearchIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTagList } from '../../../Features/lensSlice';

function TagList() {
    const dispatch = useDispatch();

    const tagListVisible = useSelector((state) => state.lens.tagList.isVisible);

    const products = useSelector((state) => state.inventoryManagement.products.products);

    const [visible, setVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const [productsList, setProductsList] = useState(products);

    const handleCancel = () => {
        dispatch(toggleTagList());
    }

    const handleChange = (e) => {
        setInputValue(e.target.value);
    }

    useEffect(() => {
        const filteredList = products.filter(item => item.product.status !== 'Draft').filter(product => product.product.productName.toLowerCase().includes(inputValue));
        setProductsList(filteredList);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);

    useEffect(() => {
        if(tagListVisible) {
            setVisible(true);
        }
        else {
            setVisible(false);
        }
    }, [tagListVisible]);

    return (
        <div className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out absolute flex flex-col gap-2 w-full h-full p-4 left-0 top-[72px] bg-[#FFFFFF] z-10`}>
            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <h1 className='font-medium text-[16px] leading-5 text-[#121212]'>Tag Product</h1>

                    <button onClick={handleCancel} className='underline font-medium text-[14px] leading-5 text-[#1055EB]'>Cancel</button>
                </div>

                <div className="rounded-lg bg-[#F5F5F5] p-4 flex items-center gap-1 border border-[#EAEAEA] focus-within:border-primaryColor">
                    <div className="size-6 flex items-center justify-center">
                        <img src={Search} alt="" />
                    </div>

                    <input 
                        value={inputValue} 
                        placeholder='Search product' 
                        className='outline-none bg-transparent w-[calc(100%-24px)] font-medium text-base text-[#121212] placeholder:text-[#666666]' 
                        type="text" 
                        onChange={handleChange} 
                        // onKeyDown={handleKeyDown} 
                    />
                </div>
            </div>

            <div className="flex flex-col max-h-1/2 overflow-y-scroll no-scrollbar pb-20">
                {productsList.map(item => {
                    return (
                        <TagProduct 
                            key={item.product.id} 
                            product={item.product} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default TagList;
